import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CakeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cake"}/>
}
